export const Divider = () => {
  return <hr className="content-teaser-group__divider" />
}
